import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@ecster/components';
import { i18n } from '@ecster/i18n';
import { LoginHelp as LoginHelpSE } from './SE/LoginHelp';
import LoginHelpFooter from './LoginHelpFooter';
import MessagePanel from '../common/MessagePanel';
import { LoginResponsivePanel } from './components/LoginResponsivePanel';
import { LoginPageTemplate } from '../common';

const Page = ({ children }) => (
    <div className="login-help-page">
        <LoginPageTemplate lazy={false}>
            <LoginResponsivePanel fullscreenInMobile maxWidth="700px">
                <div className="header">
                    <IconButton
                        ariaLabel={i18n('general.close')}
                        name="close-button"
                        id="close-button"
                        icon="icon-x"
                        onClick={() => (window.location.href = '#/start')}
                    />
                </div>
                {children}
                <MessagePanel />
            </LoginResponsivePanel>
        </LoginPageTemplate>
    </div>
);

Page.propTypes = { children: PropTypes.node.isRequired };

class LoginHelpPage extends Component {
    render() {
        return (
            <Page>
                <LoginHelpSE footer={<LoginHelpFooter />} />
            </Page>
        );
    }
}

export default LoginHelpPage;
